package net.maraclinic.app.styles

import net.maraclinic.app.displayFlexColumn
import net.maraclinic.app.theme.Dimensions
import net.maraclinic.app.theme.Fonts
import net.maraclinic.app.theme.Variables
import org.jetbrains.compose.web.ExperimentalComposeWebApi
import org.jetbrains.compose.web.css.*

@OptIn(ExperimentalComposeWebApi::class)
object AppStyleSheet : StyleSheet() {

    init {
        universal style {
            margin(0.px)
            padding(0.px)
            boxSizing("border-box")
            transitions {
                properties("color", "background-color") {
                    duration(Dimensions.TransitionDuration)
                }
            }
        }

        "html" style {
            fontFamily(Fonts.Inter)
            fontSize(Dimensions.FontScale)
            backgroundColor(Variables.Colors.Background.value())
            color(Variables.Colors.OnBackground.value())
            property("text-decoration-skip-ink", "none")
        }
    }

    val Main by style {
        displayFlexColumn()
//        padding(Dimensions.DefaultMainPadding)
        alignItems(AlignItems.Center)
        width(100.percent)
        gap(Dimensions.DefaultMainGap)
    }

}